import { useQuery, useMutation } from "@tanstack/react-query";

import {
  active2faViaEmail,
  active2faViaGoogleAuth,
  active2faViaSms,
  ChangePassword,
  confirmOtp2faViaEmail,
  confirmOtp2faViaGoogleAuth,
  confirmOtp2faViaSms,
  ConfirmOtpForgotPassword,
  ConfirmOtpTowStepLogin,
  createMoneyTransferReq,
  createSavedIban,
  deleteApiKey,
  deleteSavedIban,
  excelExport,
  externalWithdraw,
  generateApiKey,
  getApiKeys,
  getApplications,
  getDestinationIbans,
  getfixedPasswordOtp,
  getIncomes,
  getMoneyTransferReqs,
  getProfile,
  getStatements,
  getUserAvailabelBalance,
  getWithdraws,
  handleForgotPassword,
  handleLoginUser,
  internalWithdraw,
  modifyOldPassword,
  modifyPaymentFixedPassword,
  updateSavedIban,
  updateUserEmail,
  updateUserFixedPasswordState,
  VerifyOldPassword,
} from "../api/api";

export const useGetProfile = () => {
  return useQuery({
    queryKey: ["getProfile"],
    queryFn: () => getProfile(),
  });
};
export const useGetUserAvailabelBalance = () => {
  return useQuery({
    queryKey: ["getUserAvailabelBalance"],
    queryFn: () => getUserAvailabelBalance(),
  });
};
export const useLoginUser = () => {
  return useMutation({
    mutationFn: (data) => handleLoginUser(data),
  });
};
export const useForgotPassword = () => {
  return useMutation({
    mutationFn: (phone) => handleForgotPassword(phone),
  });
};
export const useConfirmOtpTowStepLogin = () => {
  return useMutation({
    mutationFn: (data) => ConfirmOtpTowStepLogin(data),
  });
};
export const useConfirmOtpForgotPassword = () => {
  return useMutation({
    mutationFn: (data) => ConfirmOtpForgotPassword(data),
  });
};
export const useChangePassword = () => {
  return useMutation({
    mutationFn: (data) => ChangePassword(data),
  });
};
export const useVerifyOldPassword = () => {
  return useMutation({
    mutationFn: (old_password) => VerifyOldPassword(old_password),
  });
};
export const useModifyOldPassword = () => {
  return useMutation({
    mutationFn: (data) => modifyOldPassword(data),
  });
};
export const useGetfixedPasswordOtp = () => {
  return useMutation({
    mutationFn: () => getfixedPasswordOtp(),
  });
};
export const useModifyPaymentFixedPassword = () => {
  return useMutation({
    mutationFn: (data) => modifyPaymentFixedPassword(data),
  });
};

export const useExcelExport = () => {
  return useMutation({
    mutationFn: ({ searchTermRef, url }) => excelExport({ searchTermRef, url }),
  });
};

export const useGetApplications = () => {
  return useQuery({
    queryKey: ["getUserInformation"],
    queryFn: () => getApplications(),
  });
};
export const useGetApiKeys = () => {
  return useQuery({
    queryKey: ["getApiKeys"],
    queryFn: () => getApiKeys(),
  });
};

export const useGenerateApiKey = () => {
  return useMutation({
    mutationFn: (title) => generateApiKey(title),
  });
};

export const useDeleteApiKey = () => {
  return useMutation({
    mutationFn: (api_key) => deleteApiKey(api_key),
  });
};
export const useDeleteSavedIban = () => {
  return useMutation({
    mutationFn: (id) => deleteSavedIban(id),
  });
};

export const useInternalWithdraw = () => {
  return useMutation({
    mutationFn: (data) => internalWithdraw(data),
  });
};
export const useExternalWithdraw = () => {
  return useMutation({
    mutationFn: (data) => externalWithdraw(data),
  });
};
export const useCreateSavedIban = () => {
  return useMutation({
    mutationFn: (data) => createSavedIban(data),
  });
};
export const useUpdateSavedIban = () => {
  return useMutation({
    mutationFn: ({ data, id }) => updateSavedIban({ data, id }),
  });
};

export const useGetDestinationIbans = ({
  currentPage,
  debouncedQueryParams,
}) => {
  return useQuery({
    queryKey: ["getDestinationIbans", currentPage, debouncedQueryParams],
    queryFn: () => getDestinationIbans({ currentPage, debouncedQueryParams }),
  });
};
export const useGetWithdraws = ({ debouncedQueryParams, currentPage }) => {
  return useQuery({
    queryKey: ["getWithdraws", currentPage, debouncedQueryParams], // Include currentPage in the queryKey
    queryFn: () => getWithdraws({ debouncedQueryParams, currentPage }),
    enabled: !!currentPage || !!debouncedQueryParams, // Optional: Only enable the query if currentPage is valid
  });
};
export const useGetStatements = ({ debouncedQueryParams, currentPage }) => {
  //console.log({ debouncedQueryParams });

  return useQuery({
    queryKey: ["getStatements", currentPage, debouncedQueryParams], // Include currentPage in the queryKey
    queryFn: () => getStatements({ debouncedQueryParams, currentPage }),
    enabled: !!currentPage || !!debouncedQueryParams, // Optional: Only enable the query if currentPage is valid
  });
};

export const useGetIncomes = ({ debouncedQueryParams, currentPage }) => {
  //console.log({ debouncedQueryParams });

  return useQuery({
    queryKey: ["getIncomes", currentPage, debouncedQueryParams], // Include currentPage in the queryKey
    queryFn: () => getIncomes({ debouncedQueryParams, currentPage }),
    enabled: !!currentPage || !!debouncedQueryParams, // Optional: Only enable the query if currentPage is valid
  });
};
export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: (email) => updateUserEmail(email),
  });
};

export const useActive2faViaSms = () => {
  return useMutation({
    mutationFn: (active) => active2faViaSms(active),
  });
};
export const useConfirmOtp2faViaSms = () => {
  return useMutation({
    mutationFn: ({ otp, active }) => confirmOtp2faViaSms({ otp, active }),
  });
};

export const useActive2faViaEmail = () => {
  return useMutation({
    mutationFn: (active) => active2faViaEmail(active),
  });
};
export const useConfirmOtp2faViaEmail = () => {
  return useMutation({
    mutationFn: ({ otp, active }) => confirmOtp2faViaEmail({ otp, active }),
  });
};
export const useActive2faViaGoogleAuth = () => {
  return useMutation({
    mutationFn: (active) => active2faViaGoogleAuth(active),
  });
};
export const useConfirmOtp2faViaGoogleAuth = () => {
  return useMutation({
    mutationFn: ({ otp, active }) =>
      confirmOtp2faViaGoogleAuth({ otp, active }),
  });
};

export const useGetMoneyTransferReqs = ({
  type,
  businessId,
  currentPage,
  pageSize,
}) => {
  return useQuery({
    queryFn: () =>
      getMoneyTransferReqs({
        type,
        businessId,
        currentPage,
        pageSize,
      }),
    queryKey: ["getMoneyTransferReqs", currentPage],
  });
};

export const useUpdateUserFixedPasswordState = () => {
  return useMutation({
    mutationFn: (state) => updateUserFixedPasswordState(state),
  });
};
